import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  wrapFormInput: {
    width: '67%',
  },
}));

export default useStyles;
